(function() {
  const FORM_SUBMIT_URL = 'https://script.google.com/macros/s/AKfycbx0MBQccM9TPo-DjXFc_dgIqJYNxh2SIDxNcL8oU2O3814WVuiqJ21ez9slHqof2RaoaA/exec';
  const SUCCESS_HIDE_DELAY = 2000;

  const retailForm = {
    fields: [],
    formError: null,
    formSuccess: null,
    submitButton: null,
    successTimeout: null,

    addFieldsEventListeners: function() {
      this.fields.forEach(field => {
        field.addEventListener('focus', () => {
          field.classList.remove('error');
        });
      });
    },

    addSubmitButtonEventListener: function() {
      this.submitButton.addEventListener('click', () => {
        const isValid = this.validate();

        if (isValid) {
          this.submit();
        }
      });
    },

    clearFields: function() {
      this.fields.forEach(field => {
        field.value = '';
      });
    },

    getFormData: function() {
      const data = {};

      this.fields.forEach(field => {
        data[field.name] = field.value;
      });

      data.listId = this.listId;

      return data;
    },

    hideFormError: function() {
      this.formError.classList.remove('form-page__error--visible');
    },

    init: function() {
      this.submitButton = document.querySelector('.form-page__button');
      this.fields = document.querySelectorAll('.form-page__field input, .form-page__field select');
      this.formError = document.querySelector('#form-error');
      this.formSuccess = document.querySelector('.form-page__success');
      this.listId = document.querySelector('.form-page').dataset.id

      this.addFieldsEventListeners();
      this.addSubmitButtonEventListener();
    },

    showFormError: function(message) {
      this.formError.querySelector('.form-page__error-text').innerText = message;
      this.formError.classList.add('form-page__error--visible');
    },

    showFormSuccess: function(callback) {
      this.formSuccess.classList.add('form-page__success--visible');

      clearTimeout(this.successTimeout);

      this.successTimeout = window.setTimeout(() => {
        if (typeof callback === 'function') {
          callback();
        }

        this.formSuccess.classList.remove('form-page__success--visible');
      }, SUCCESS_HIDE_DELAY);
    },

    submit: function() {
      this.hideFormError();
      this.submitButton.classList.add('form-page__button--loading');

      fetch(FORM_SUBMIT_URL, {
        method: 'POST',
        body: JSON.stringify(this.getFormData())
      })
        .then(response => {
          this.submitButton.classList.remove('form-page__button--loading');
          return response.json();
        })
        .then(body => {
          if (body.success) {
            this.showFormSuccess(() => {
              this.clearFields();
            });
          } else
          if (body.message) {
            this.showFormError(body.message);
          }
        })
    },

    validate: function() {
      let isValid = true;

      this.fields.forEach(field => {
        if (!field.value) {
          field.classList.add('error');

          const errorField = field.parentNode.querySelector('.form-page__error');

          if (errorField) {
            errorField.querySelector('.form-page__error-text').innerText = 'Please fill this field.';
          }

          isValid = false;
        }
      });

      return isValid;
    }
  };

  window.addEventListener('DOMContentLoaded', () => {
    retailForm.init();
  });
})();
